import { Modal } from "@/base/components/index";
import { ContentRenderer } from "@/components/content-renderer/index";
import { LocalizationText } from "@/app/index";
import { ModalLicenseAgreementFooter } from "./modal-license-agreement-footer";
import { useModalLicenseAgreementStyles } from "./modal-license-agreement.styles";
import { useContextModalLicenseAgreement } from "../context/index";

export const ModalLicenseAgreement = () => {
  const { styles } = useModalLicenseAgreementStyles();
  const { status, data } = useContextModalLicenseAgreement();

  return (
    <Modal
      width="100%"
      className={styles.modal}
      classNames={{
        mask: styles.modalMask,
        content: styles.modalContent,
      }}
      maskClosable={false}
      open={status === "show"}
      closable={false}
      title={<LocalizationText value="modal.license.agreement.title" />}
      footer={<ModalLicenseAgreementFooter />}
    >
      {data?.Text && (
        <ContentRenderer
          type="html"
          content={data?.Text}
          className={styles.content}
        />
      )}
    </Modal>
  );
};
